import { type ChangeEvent, type CompositionEvent, useRef } from 'react';

import { normalizeEntryCode } from '@/shared/utils';

/**
 * 코드 입력칸용 onChange/IME 핸들러 묶음.
 * 입력 중(onChange)에도 normalizeEntryCode(공백·특수 제거, 대문자, 선택적 길이 cap)를
 * 적용해 인풋에 정규화된 값만 남게 한다. 단 IME 조합 중에는 정규화를 미뤄
 * 한글 조합 글자가 즉시 지워지지 않게 하고(P0-2), 조합이 끝나면 정규화한다.
 * 값 소유는 호출측에 둔다 — 정규화 결과를 onValue 로 전달한다.
 */
export function useCodeInputHandlers(
  onValue: (next: string) => void,
  maxLength?: number,
) {
  const isComposingRef = useRef(false);

  return {
    onChange: (event: ChangeEvent<HTMLInputElement>) =>
      onValue(
        isComposingRef.current
          ? event.target.value
          : normalizeEntryCode(event.target.value, maxLength),
      ),
    onCompositionStart: () => {
      isComposingRef.current = true;
    },
    onCompositionEnd: (event: CompositionEvent<HTMLInputElement>) => {
      isComposingRef.current = false;
      onValue(normalizeEntryCode(event.currentTarget.value, maxLength));
    },
  };
}
